import {
  Button,
  Card,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  FormHelperText,
  Grid,
  TextField,
  Typography,
} from "@mui/material";
import { Box } from "@mui/system";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { Controller, useForm } from "react-hook-form";
import { showAlert } from "../../../actions/alert";
import ControlledTable from "../../../component/ControlledTable";
import { handleAxiosError } from "../../../config/action-config";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getNotesList } from "../../../api/sales";

import { notesListTable as tableDef } from "../../../config/grid-columns-defs";
import { createLeadNote, getPdfViewer } from "../../../api/partnerLead";
import { CloudUpload } from "@mui/icons-material";
import {
  createCrmLeadNote,
  getCrmNotesList,
  getCrmPdfViewer,
} from "../../../api/crmLeads";

export default function ViewCrmLeadsNotes({ leadId }) {
  const user = useSelector((state) => state.user);
  const dispatch = useDispatch();
  const [totalCount, setTotalCount] = useState(0);
  const [rows, setRows] = useState([]);
  const [pageNumber, setPageNumber] = useState(0);
  const [itemDialog, setItemDialog] = useState(false);
  const getRows = async (numRows, startRow) => {
    return getCrmNotesList(
      { lead_id: leadId, limit: numRows, offset: startRow },
      user.token
    )
      .then((res) => {
        setTotalCount(parseInt(res.data.total) === 0 ? -1 : res.data.total);
        return res.data.records;
      })
      .catch((err) => {
        handleAxiosError(err, dispatch);
        return [];
      });
  };
  const refreshTable = async () => {
    try {
      const { data } = await getCrmNotesList(
        { lead_id: leadId, limit: 10, offset: 0 },
        user.token
      );
      setTotalCount(parseInt(data.total) === 0 ? -1 : parseInt(data.total));
      setRows(data.records);
    } catch (err) {
      handleAxiosError(err, dispatch);
    }
  };
  const onItemDialogSubmit = async (formData, postData) => {
    try {
      const { data } = await createCrmLeadNote(
        formData,
        {
          lead_id: leadId,
          note_description: postData.note_description,
          activity: postData.activity,
          note_date: postData.note_date,
        },
        user.token
      );
      refreshTable();
      dispatch(showAlert(data.msg));
      setItemDialog(false);
    } catch (error) {
      handleAxiosError(error, dispatch);
    }
  };

  return (
    <div>
      <Box sx={{ display: "flex", columnGap: 1, p: 2, borderBottom: 1 }}>
        <Button
          variant="contained"
          style={{ padding: "5px 7px" }}
          onClick={() => {
            setItemDialog(true);
          }}
          className="blue-button"
        >
          Add Note
        </Button>
      </Box>
      <div className="ag-theme-material" style={{ height: "300px" }}>
        <ControlledTable
          rows={rows}
          columnDefs={tableDef}
          getRows={getRows}
          totalCount={totalCount}
          onChange={setRows}
          onPageNumberChange={setPageNumber}
          pageSize={10}
          pageNumber={pageNumber}
          pagination={true}
          hasActionButtons={false}
        />
      </div>
      <ItemDialogNoteTab
        open={itemDialog}
        setOpen={setItemDialog}
        onSubmit={onItemDialogSubmit}
      />
    </div>
  );
}
const emptyItemData = {
  lead_id: "",
  note_description: "",
  activity: "",
};
function ItemDialogNoteTab({ open, setOpen, onSubmit }) {
  const user = useSelector((state) => state.user);
  const [loader, setLoader] = useState(false);
  const [selectedFile, setSelectedFile] = useState("");
  const [isSelected, setIsSelected] = useState(false);
  const dispatch = useDispatch();
  const {
    register,
    handleSubmit,
    control,
    formState: { errors },
  } = useForm({ defaultValues: emptyItemData });
  let obj = tableDef.find((o) => o.headerName === "Document");
  if (obj === undefined) {
    tableDef.push({
      headerName: "Document",
      field: "filename",
      resizable: true,
      minWidth: 180,
      onCellClicked: (params) => {
        getDocDownloadData(params.data.note_id);
      },
    });
  }

  const submit = (data) => {
    const formData = new FormData();
    if (selectedFile == "") {
      setOpen("ATTACHMENTS_TAB");
      return dispatch(showAlert("Attachment can't be empty"));
    }
    const appenddata = formData.append("myFile", selectedFile);

    setLoader(true);
    onSubmit(formData, data).then(() => {
      setLoader(false);
      setIsSelected(false);
      setSelectedFile("");
    });
  };
  const changeHandler = (event) => {
    setSelectedFile(event.target.files[0]);
    setIsSelected(true);
  };
  const getDocDownloadData = (id) => {
    const token = user.token;
    getCrmPdfViewer(id, token)
      .then((blob) => {
        const file = window.URL.createObjectURL(blob.data);

        window.open(file, "_blank");
      })
      .catch((err) => {
        handleAxiosError(err, dispatch);
      });
  };

  return (
    <Dialog
      open={open}
      onClose={() => {
        // setOpen(false);
      }}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title" sx={{ textTransform: "capitalize" }}>
        Lead Note
      </DialogTitle>
      <DialogContent>
        <Grid container width={500} spacing={1} py={1}>
          <Grid item xs={12} sm={6} md={6}>
            <FormControl fullWidth required error={Boolean(errors.follow_date)}>
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <Controller
                  render={(props) => (
                    <DatePicker
                      value={props.value || ""}
                      label="Note Date"
                      onChange={(nv) => {
                        props.onChange(nv.toLocaleDateString());
                      }}
                      renderInput={(params) => <TextField {...params} />}
                    />
                  )}
                  rules={{
                    required: "Note Date is required",
                  }}
                  name="note_date"
                  control={control}
                />
              </LocalizationProvider>
              <FormHelperText>{errors.follow_date?.message}</FormHelperText>
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={6} md={6}>
            <TextField
              type="text"
              label="Activity"
              name="activity"
              fullWidth
              inputRef={register({
                required: "Activity is required.",
              })}
              required
              error={Boolean(errors.activity)}
              helperText={errors.activity?.message}
            />
          </Grid>
          <Grid item xs={12} sm={12} md={12}>
            <TextField
              type="text"
              label="Description"
              name="note_description"
              fullWidth
              multiline={true}
              rows={3}
              inputRef={register({
                required: "Description is required.",
              })}
              required
              error={Boolean(errors.note_description)}
              helperText={errors.note_description?.message}
            />
          </Grid>
          <Grid item xs={12} sm={12} md={12}>
            <Card sx={{ boxShadow: "none !important" }}>
              <div class="upload-files-container">
                <div class="drag-file-area">
                  <div class="upload-icon">
                    <CloudUpload sx={{ fontSize: 40, color: "#08459c" }} />
                  </div>
                  <h6 class="dynamic-message"> Drag & drop any file here </h6>
                  <div class="browse-files">
                    <input
                      className="file-upload"
                      type="file"
                      name="file"
                      onChange={changeHandler}
                    />
                    {isSelected ? (
                      <Box>
                        <Typography>Filename: {selectedFile.name}</Typography>
                        <Typography>Filetype: {selectedFile.type}</Typography>
                        <Typography>
                          Size in bytes: {selectedFile.size}
                        </Typography>
                        <Typography>
                          lastModifiedDate:{" "}
                          {selectedFile.lastModifiedDate.toLocaleDateString()}
                        </Typography>
                      </Box>
                    ) : (
                      <Typography>Select a file to show details</Typography>
                    )}
                  </div>
                </div>
              </div>
            </Card>
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={() => {
            setOpen(false);
          }}
          className="cancel-button"
        >
          Cancel
        </Button>
        <Button
          disabled={/^Trial_User$/i.test(user.role) ? true : false}
          className="blue-button"
          onClick={handleSubmit(submit)}
        >
          {"Submit"}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
